<div fxLayout="column" fxFlex>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px"
    fxFlex="none" style="align-items: center;">
    <div fxFlex fxLayout="row" fxLayoutAlign="start center">
      <h2 mat-dialog-title style="margin:0">Visualização do Arquivo</h2>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" *ngIf="!onlyLink || fileName"
      fxFlex="none">
      <button mat-button (click)="downloadFile()"
        [disabled]="!fileUrl || isDownloading">
        <mat-icon *ngIf="!isDownloading">download</mat-icon>
        <mat-spinner *ngIf="isDownloading" diameter="20"
          style="display: inline-block;"></mat-spinner>
        <span class="button-label">{{ isDownloading ? 'Baixando...' : 'Download'
          }}</span>
      </button>
      <button mat-button (click)="shareFile()"
        *ngIf="showShareButton"
        [disabled]="!fileUrl && !shareText">
        <mat-icon>share</mat-icon>
        <span class="button-label">Compartilhar</span>
      </button>
    </div>
  </div>

  <div *ngIf="pixBrCodes?.length" style="padding: 8px 16px 4px;">
    <div style="font-size: 11px; font-weight: 600; color: #1B5E20; letter-spacing: 0.5px; margin-bottom: 6px;">
      CÓDIGO PIX — COPIA E COLA
    </div>
    <div *ngFor="let code of pixBrCodes; let i = index"
         style="margin-bottom: 8px; background: #F1F8E9; border: 1px solid #AED581; border-radius: 6px; padding: 8px 12px;">
      <div *ngIf="pixBrCodes!.length > 1"
           style="font-size: 10px; color: #558B2F; font-weight: 600; margin-bottom: 4px;">
        PARCELA {{i + 1}} de {{pixBrCodes!.length}}
      </div>
      <div style="font-size: 10px; color: #333; word-break: break-all; font-family: monospace; line-height: 1.5;">
        {{code}}
      </div>
      <div style="text-align: center; margin-top: 8px;">
        <button mat-stroked-button
                style="border-color: #388E3C; color: #388E3C; font-size: 12px; height: 32px; line-height: 32px;"
                (click)="copyPixCode(i)">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 4px;">
            {{copiedIndex === i ? 'check_circle' : 'content_copy'}}
          </mat-icon>
          {{copiedIndex === i ? 'Copiado!' : 'Copiar código'}}
        </button>
      </div>
    </div>
  </div>

  <div fxFlex>
    <mat-dialog-content>
      <div *ngIf="fileUrl; else noFile">
        <div *ngIf="isViewerLoading"
          style="height: 70vh; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:12px; color:#14294E; font-weight:600;">
          <mat-spinner diameter="52"></mat-spinner>
          <span>A visualização do boleto está carregando...</span>
        </div>
        <iframe [src]="fileUrl | safeUrl" width="100%" height="1000px"
          [style.display]="isViewerLoading ? 'none' : 'block'"
          style="border: none;"
          (load)="onViewerLoaded()"></iframe>
      </div>
      <ng-template #noFile>
        <p>Nenhum arquivo disponível para visualização.</p>
      </ng-template>
    </mat-dialog-content>
  </div>
</div>
